import React from "react";
import styles from "../editor.module.scss";

const TableElement = ({ attributes, children, element }) => {
  return (
    <div className={styles.table}>
      <table className="oppssss">
        <tbody {...attributes}>{children}</tbody>
      </table>
    </div>
  );
};

export default TableElement;
